import React, { useEffect, useState, useContext, useRef } from "react";
import "moment/locale/th";
import Input from "../../material/input/Input";
import { useNavigate, useLocation } from "react-router-dom";
import * as AdminApi from "../../../service/adminApi";
import { RedirectCode400 } from "../../RedirectCode400";
import { CurrentUserContext } from "../../../App";
import DialogTailwindConfirm from "../../DialogTailwindConfirm";
import { FaCircle, FaEye, FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import format from "date-fns/format";
import TableSearchV1 from "../../tableV1/tableSearchV1";
import PageHeaderV2 from "../../pageheaderV2/PageHeaderV2";

function UserManament() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const userAuthCurrent = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();
  const SESSION_KEY = "userManagement_state";

  const getInitialState = () => {
    try {
      const saved = sessionStorage.getItem(SESSION_KEY);
      if (saved) return JSON.parse(saved);
    } catch {}
    return null;
  };

  const savedState = getInitialState();

  const defaultFilters = {
    id_card: "",
    fname: "",
    lname: "",
    phone_number: "",
    license_number: "",
    "hospital.hospital_name": "",
    "laboratory.laboratory_name": "",
    "auth.role[0]": "ADMIN",
    "auth.enable": "",
    "auth.approve": "",
    medical_type: "",
    "create_date.date": "",
  };

  const [loading, setLoading] = useState(false);
  const [userDataList, setUserDataList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(savedState?.page ?? 1);
  const [maxPage, setMaxPage] = useState(1);

  //Dialog
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [isDialogOpenApproved, setIsDialogOpenApproved] = useState(false);
  const [selectedDataApproved, setSelectedDataApproved] = useState(null);

  const abortControllerRef = useRef(null);

  const [filters, setFilters] = useState(savedState?.filters ?? defaultFilters);

  const [debouncedFilters, setDebouncedFilters] = useState(savedState?.filters ?? defaultFilters);
  const [sortBy, setSortBy] = useState(savedState?.sortBy ?? { id: "", desc: false });

  useEffect(() => {
    const professionalRoles = ["MEDICAL_PERSONNEL", "LABORATORY_ADMIN", "LABORATORY_PERSONNEL"];
    if (!professionalRoles.includes(filters["auth.role[0]"])) {
      setFilters((prev) => ({
        ...prev,
        medical_type: "",
        license_number: "",
      }));
    }
  }, [filters["auth.role[0]"]]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      setDebouncedFilters(filters);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filters]);

  useEffect(() => {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify({ filters, page, sortBy }));
  }, [filters, page, sortBy]);

  useEffect(() => {
    getUserDataList();
  }, [page, debouncedFilters, sortBy]);

  useEffect(() => {
    if (!userAuthCurrent.auth.role[0] === "ADMIN") {
      navigate("/login");
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // getUserDataList();
  }, [page, filters, sortBy]);

  const getUserDataList = async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    setLoading(true);

    let res = await AdminApi.getUserDataList(page, 10, filters, controller.signal, sortBy.id, sortBy.desc ? "desc" : "asc");

    if (res === null) return; 

    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setUserDataList(res["data"]["user_data_list"]);
        setTotal(res["data"]["amount"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  // const getUserDataList = async () => {
  //   setLoading(true);
  //   let res = await AdminApi.getUserDataList(page, 10, filters);
  //   setLoading(false);
  //   if (res) {
  //     if (res["data"]["code"] === 200) {
  //       setUserDataList(res["data"]["user_data_list"]);
  //       setTotal(res["data"]["amount"]);
  //       setMaxPage(Math.ceil(res["data"]["amount"] / 10));
  //     } else if (res["data"]["code"] === 403) {
  //       navigate(RedirectCode400());
  //     } else {
  //       setIsMessage({
  //         type: "warning",
  //         data: res["data"]["message_th"] || res["data"]["message"],
  //       });
  //     }
  //   } else {
  //     setIsMessage({
  //       type: "error",
  //       data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
  //     });
  //   }
  // };

  const ManageUserApprove = async (uid, approve) => {
    let res = "";
    res = await AdminApi.ManageUserApprove(uid, approve);
    if (res) {
      if (res["data"]["code"] === 200) {
        getUserDataList(false);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  //เปิด Dialog
  const handleConfirm = async (confirmed, data) => {
    setIsDialogOpen(false);
    if (confirmed && data) {
      if (data?.uid && typeof data.isAuthDisabled !== "undefined") {
        let res = "";
        res = await AdminApi.ManageUserEnable(data.uid, data.isAuthDisabled);
        if (res) {
          if (res["data"]["code"] === 200) {
            getUserDataList(false);
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    }
  };

  // ฟังก์ชันเปิด dialog พร้อมบันทึกข้อมูล row ที่ต้องการ
  const openDialog = (rowData) => {
    setSelectedData(rowData);
    setIsDialogOpen(true);
  };

  //เปิด Dialog Approved
  const handleConfirmApproved = async (confirmed, data) => {
    setIsDialogOpenApproved(false);
    if (confirmed && data) {
      ManageUserApprove(data.uid, data.isAuthDisabled);
    }
  };
  const openDialogApproved = (rowData) => {
    setSelectedDataApproved(rowData);
    setIsDialogOpenApproved(true);
  };

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  // column admin
  const optionRoleList = [
    {
      value: "ADMIN",
      name: "แอดมิน",
    },
    {
      value: "MEDICAL_PERSONNEL",
      name: "แพทย์/เภสัชกร",
    },
    {
      value: "LABORATORY_ADMIN",
      name: "Admin ห้องปฏิบัติการ",
    },
    {
      value: "LABORATORY_PERSONNEL",
      name: "Staff ห้องปฏิบัติการ",
    },
    {
      value: "PATIENT",
      name: "ประชาชน",
    },
    {
      value: "EXECUTIVE",
      name: "ผู้บริหาร",
    },
    {
      value: "HOSPITAL",
      name: "โรงพยาบาล",
    },
    {
      value: "HOSPITAL_PERSONNEL",
      name: "เจ้าหน้าที่โรงพยาบาล",
    },
  ];

  const optionStatusList = [
    {
      value: true,
      name: "Active",
    },
    {
      value: false,
      name: "InActive",
    },
  ];

  const optionApproveList = [
    {
      value: true,
      name: "อนุมัติเเล้ว",
    },
    {
      value: false,
      name: "ยังไม่อนุมัติ",
    },
  ];

  const optionMedicalTypeList = [
    { value: "แพทยสภา", name: "แพทยสภา" },
    { value: "สภาเทคนิคการแพทย์", name: "สภาเทคนิคการแพทย์" },
    { value: "สภาเภสัชกรรม", name: "สภาเภสัชกรรม" },
    { value: "ทันตแพทยสภา", name: "ทันตแพทยสภา" },
  ];

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "ชื่อ",
      accessor: "fname",
      Filter: "text",
    },
    {
      Header: "นามสกุล",
      accessor: "lname",
      Filter: "text",
    },
    {
      Header: "เบอร์โทร",
      accessor: "phone_number",
      Filter: "text",
    },
    ...(filters["auth.role[0]"] === "MEDICAL_PERSONNEL" ||
    filters["auth.role[0]"] === "LABORATORY_ADMIN" ||
    filters["auth.role[0]"] === "LABORATORY_PERSONNEL"
      ? [
          {
            Header: "ประเภทวิชาชีพ",
            accessor: "medical_type",
            Filter: "select",
            DataFilter: optionMedicalTypeList,
          },
          {
            Header: "เลขใบประกอบวิชาชีพ",
            accessor: "license_number",
            Filter: "text",
          },
        ]
      : []),
    ...(filters["auth.role[0]"] === "LABORATORY_ADMIN" ||
    filters["auth.role[0]"] === "LABORATORY_PERSONNEL"
      ? [
          {
            Header: "ไฟล์แนบ",
            accessor: "attachment_file",
            Cell: ({ row }) => {
              const fileUrl = row.original.attachment_file?.url;
              return fileUrl ? (
                <button onClick={() => window.open(fileUrl, "_blank")}>
                  ไฟล์
                </button>
              ) : (
                "ไม่มีไฟล์"
              );
            },
          },
        ]
      : []),
    ...(filters["auth.role[0]"] === "LABORATORY_ADMIN" ||
    filters["auth.role[0]"] === "LABORATORY_PERSONNEL"
      ? [
          {
            Header: "ชื่อห้องเเลป",
            accessor: "laboratory",
            Cell: ({ row }) => {
              const name = row.original.laboratory?.laboratory_name;
              return name ? <div>{name}</div> : "ไม่มีไฟล์";
            },
            Filter: "text",
          },
        ]
      : []),
    ...(filters["auth.role[0]"] === "MEDICAL_PERSONNEL" ||
    filters["auth.role[0]"] === "HOSPITAL" ||
    filters["auth.role[0]"] === "HOSPITAL_PERSONNEL"
      ? [
          {
            Header: "โรงพยาบาล",
            accessor: "hospital.hospital_name",
            Cell: ({ row }) => {
              const name = row.original.hospital?.hospital_name;
              return name ? <div>{name}</div> : "-";
            },
            Filter: "text",
          },
        ]
      : []),
    {
      Header: "ประเภท",
      accessor: "auth.role[0]",
      DataFilter: optionRoleList,
      Cell: ({ row }) => {
        const roleValue = row.original.auth.role[0];
        const roleObj = optionRoleList.find((r) => r.value === roleValue);
        return roleObj ? roleObj.name : "-";
      },
      Filter: "select",
    },
    {
      Header: "อนุมัติผู้ใช้งาน",
      accessor: "auth.approve",
      DataFilter: optionApproveList,
      Filter: "select",
      Cell: (row) => (
        <div>
          {row.row.original.auth.approve === true ? (
            <div className="flex justify-center items-center">
              <div
                style={{ color: "#64BD86", fontSize: "14px" }}
                className="flex justify-center items-center gap-2"
              >
                <FaCircle />
                อนุมัติแล้ว
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialogApproved({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง อนุมัติ ผู้ใช้งาน ${row.row.original.fname} ใช่หรือไม่ `,
                    uid: row.row.original.uid,
                    isAuthDisabled: !row.row.original.auth.approve,
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                <FaCircle />
                ยังไม่อนุมัติ
              </button>
            </div>
          )}
        </div>
      ),
    },
    {
      Header: "สถานะผู้ใช้งาน",
      accessor: "auth.enable",
      DataFilter: optionStatusList,
      Filter: "select",
      Cell: (row) => (
        <div>
          {row.row.original.uid != "cf637680-d746-5fe6-977a-7d0bca9ae9f5" &&
          userAuthCurrent?.uid != row.row.original.uid ? (
            row.row.original.auth.enable === true ? (
              <div
                className="flex justify-center items-center"
                style={{ color: "#64BD86", fontSize: "14px" }}
              >
                <button
                  onClick={() =>
                    openDialog({
                      message: `กรุณายืนยันการทำรายการ คุณกำลัง Inactive ผู้ใช้งาน ${row.row.original.fname} ใช่หรือไม่ `,
                      uid: row.row.original.uid,
                      isAuthDisabled: !row.row.original.auth.enable,
                    })
                  }
                  className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#64BD86] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-hard-green "
                >
                  <FaCircle /> Active
                </button>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <button
                  onClick={() =>
                    openDialog({
                      message: `กรุณายืนยันการทำรายการ คุณกำลัง Active ผู้ใช้งาน ${row.row.original.fname} ใช่หรือไม่ `,
                      uid: row.row.original.uid,
                      isAuthDisabled: !row.row.original.auth.enable,
                    })
                  }
                  className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
                >
                  <FaCircle /> Inactive
                </button>
              </div>
            )
          ) : (
            <div
              style={{ color: "#64BD86", fontSize: "14px" }}
              className="flex justify-center items-center gap-2"
            >
              <FaCircle />
              Active
            </div>
          )}
        </div>
      ),
    },
    {
      Header: "วันที่สมัครสมาชิก",
      accessor: "create_date.date",
      Filter: "date",
      Cell: ({ row }) => {
        const dateStr = row.original.create_date.date; 
        if (!dateStr) return "-";
        const [year, month, day] = dateStr.split("-");
        const thaiYear = parseInt(year) + 543;
        return `${day}/${month}/${thaiYear}`;
      }
    },
    {
      Header: "#",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const i = row.original;

        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#DFEEFA 0% 0% no-repeat padding-box" }}
              onClick={() => {
                navigate(
                  `/admin/usermanagement/view-usermanagement/${i["uid"]}`,
                  {
                    state: {
                      type: "usermanagement",
                      id: i["uid"],
                      title: i["fname"],
                    },
                  },
                );
              }}
            >
              <FaEye className="text-[#46A8F4] h-[14px]" />
            </div>
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#AFEBE3 0% 0% no-repeat padding-box" }}
              onClick={() => {
                navigate("/admin/usermanagement/edit-usermanagement", {
                  state: {
                    type: "edit-usermanagement",
                    id: i["uid"],
                    // hospital_id: i["hospital"]
                    //   ? i["hospital"]["hospital_id"]
                    //   : "",
                    // role: i["auth"]["role"][0],
                    // prefix: i["pname"],
                    // firstName: i["fname"],
                    // lastName: i["lname"],
                    // gender: i["gender"],
                    // birthday: i["birthday"],
                    // phone: i["phone_number"],
                    // email: i["email"],
                    // zip_code: i["current_address"]["post_code"],
                  },
                });
              }}
            >
              <FaEdit className="text-[#00917E] h-[14px]" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="min-w-[767px] overflow-x-auto">
      <div className="mt-[60px]"></div>
      <div>
        <PageHeaderV2 titlename="ผู้ใช้งานระบบ" />

        <TableSearchV1
          columns={columns}
          data={userDataList}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={total}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          addData={{
            name: "เพิ่มผู้ใช้งาน",
            url: "/admin/usermanagement/add-usermanagement",
            type: "add-usermanagement",
          }}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
        {isDialogOpen && selectedData && (
          <DialogTailwindConfirm
            onConfirm={handleConfirm}
            onCancel={handleConfirm}
            data={selectedData}
          />
        )}

        {isDialogOpenApproved && selectedDataApproved && (
          <DialogTailwindConfirm
            onConfirm={handleConfirmApproved}
            onCancel={handleConfirmApproved}
            data={selectedDataApproved}
          />
        )}
      </div>
    </div>
  );
}

export default UserManament;
